import consumer from "./consumer"

let subscription
let activeHistory

function disconnect() {
  if (subscription) consumer.subscriptions.remove(subscription)
  subscription = null
  activeHistory = null
}

document.addEventListener("turbolinks:before-cache", disconnect)
document.addEventListener("turbolinks:load", () => {
  disconnect()
  const history = document.getElementById("message-history")
  if (!history) return
  activeHistory = history
  let loading = false
  let pending = false
  const refresh = async () => {
    if (activeHistory !== history) return
    if (loading) { pending = true; return }
    loading = true
    try {
      const response = await fetch(history.dataset.historyUrl, { credentials: "same-origin", headers: { Accept: "application/json" } })
      if (!response.ok) return
      const data = await response.json()
      if (activeHistory === history && history.isConnected) history.innerHTML = data.html
    } catch (_error) {
      // Reconnecting refreshes history after a temporary network interruption.
    } finally {
      loading = false
      if (pending) { pending = false; refresh() }
    }
  }
  subscription = consumer.subscriptions.create(
    { channel: "MessageChannel", receiver_id: history.dataset.receiverId },
    { connected: refresh, received: refresh }
  )
})
